package com.essntl.core.stripe.data.response

import com.essntl.core.stripe.domain.models.Price
import kotlinx.serialization.Serializable

@Serializable
internal data class PriceDto(
    val id: String,
) {
    fun toModel() =
        Price(
            id = id,
        )
}
